import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Cartonization_ds_get_picking_tasks_by_shipmentIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentId: number }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ChainHead?: number, ExpectedInventoryAmount?: number, ExpectedInventoryAmountPackId?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSerialNumberId?: number, ExpectedTargetShippingContainerId?: number, LotId?: number, MaterialId?: number, OperationCodeId?: number, OrderId?: number, OrderLineNumber?: number, PickSlipId?: number, ProjectId?: number, ShipmentId?: number, StatusId?: number, VendorLotId?: number, VolumeUomId?: number, WarehouseId?: number, WeightUomId?: number, Material?: { Id?: number, PackagingLookups?: { BasePackagingQuantity?: number, DimensionUomId?: number, Height?: number, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, StackableGroupId?: string, StackableHeight?: number, StackableLength?: number, StackableVolume?: number, StackableWidth?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Packaging?: { Id?: number, Name?: string, ShortName?: string } }[] }, ShipmentLine?: { Id?: number }, HardAllocations?: { Id?: number, LicensePlateId?: number, LocationId?: number, SerialNumberId?: number, StatusId?: number, Details?: { Id?: number, Amount?: number, LotId?: number, MaterialId?: number, PackagedAmount?: number, PackagedId?: number }[] }[], Shipment?: { Id?: number, ContainerSize?: string }, ActualSourceLocation?: { Id?: number, IsPrimaryPick?: boolean } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Cartonization/datasources/ds_get_picking_tasks_by_shipmentId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipmentId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ChainHead?: number, ExpectedInventoryAmount?: number, ExpectedInventoryAmountPackId?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSerialNumberId?: number, ExpectedTargetShippingContainerId?: number, LotId?: number, MaterialId?: number, OperationCodeId?: number, OrderId?: number, OrderLineNumber?: number, PickSlipId?: number, ProjectId?: number, ShipmentId?: number, StatusId?: number, VendorLotId?: number, VolumeUomId?: number, WarehouseId?: number, WeightUomId?: number, Material?: { Id?: number, PackagingLookups?: { BasePackagingQuantity?: number, DimensionUomId?: number, Height?: number, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, StackableGroupId?: string, StackableHeight?: number, StackableLength?: number, StackableVolume?: number, StackableWidth?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Packaging?: { Id?: number, Name?: string, ShortName?: string } }[] }, ShipmentLine?: { Id?: number }, HardAllocations?: { Id?: number, LicensePlateId?: number, LocationId?: number, SerialNumberId?: number, StatusId?: number, Details?: { Id?: number, Amount?: number, LotId?: number, MaterialId?: number, PackagedAmount?: number, PackagedId?: number }[] }[], Shipment?: { Id?: number, ContainerSize?: string }, ActualSourceLocation?: { Id?: number, IsPrimaryPick?: boolean } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Cartonization/datasources/ds_get_picking_tasks_by_shipmentId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipmentId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualSourceLicensePlateId?: number, ChainHead?: number, ExpectedInventoryAmount?: number, ExpectedInventoryAmountPackId?: number, ExpectedPackagedAmount?: number, ExpectedPackagedPackId?: number, ExpectedSerialNumberId?: number, ExpectedTargetShippingContainerId?: number, LotId?: number, MaterialId?: number, OperationCodeId?: number, OrderId?: number, OrderLineNumber?: number, PickSlipId?: number, ProjectId?: number, ShipmentId?: number, StatusId?: number, VendorLotId?: number, VolumeUomId?: number, WarehouseId?: number, WeightUomId?: number, Material?: { Id?: number, PackagingLookups?: { BasePackagingQuantity?: number, DimensionUomId?: number, Height?: number, Length?: number, PalletHigh?: number, PalletTie?: number, ShippingVolume?: number, ShippingWeight?: number, StackableGroupId?: string, StackableHeight?: number, StackableLength?: number, StackableVolume?: number, StackableWidth?: number, Volume?: number, VolumeUomId?: number, Weight?: number, WeightUomId?: number, Width?: number, Packaging?: { Id?: number, Name?: string, ShortName?: string } }[] }, ShipmentLine?: { Id?: number }, HardAllocations?: { Id?: number, LicensePlateId?: number, LocationId?: number, SerialNumberId?: number, StatusId?: number, Details?: { Id?: number, Amount?: number, LotId?: number, MaterialId?: number, PackagedAmount?: number, PackagedId?: number }[] }[], Shipment?: { Id?: number, ContainerSize?: string }, ActualSourceLocation?: { Id?: number, IsPrimaryPick?: boolean } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.shipmentId)) {
      missingRequiredInParams.push('\'shipmentId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Cartonization/datasources/ds_get_picking_tasks_by_shipmentId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      shipmentId: number    }) {
        if(isNil(inParams.shipmentId)) {
          return true; 
        }
      return false;
    }
}
